"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _app = require("@package/app");

var _react = _interopRequireDefault(require("react"));

var _Status = _interopRequireDefault(require("./Status"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

var _excluded = ["status", "payments"];

function StatusInfo(_ref) {
  var status = _ref.status,
      payments = _ref.payments,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  try {
    var lastPaymentIndex = payments.length - 1;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement(_Status["default"], {
      status: status === null || status === void 0 ? void 0 : status['code'],
      type: 'background',
      payment: payments[lastPaymentIndex],
      "data-locator": props['data-locator']
    }));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = /*#__PURE__*/_react["default"].memo(StatusInfo);

exports["default"] = _default;